import { fromJS } from 'immutable';

import {
	Action,
	OBJECT_FAILED,
	OBJECT_REQUESTED,
	OBJECT_SUCCEEDED,
	LOCAL_CHANGE_OBJECT_FIELD_REQUESTED,
	LOCAL_CREATE_INITIAL_OBJECT,
	REMOVE_OBJECT,
	FILTERS_CHANGED,
} from './actions';
import {
	initialState,
	instanceStoreRecord,
	ObjectStoreRecordType,
} from './store';

export const reducer = (
	state: ObjectStoreRecordType = initialState,
	action: Action
): ObjectStoreRecordType => {
	switch (action.type) {
		case OBJECT_REQUESTED: {
			let inState = state;
			if (!inState.hasIn(['instances', action.instanceId])) {
				inState = inState.setIn(
					['instances', action.instanceId],
					instanceStoreRecord()
				);
			}
			return inState
				.setIn(['instances', action.instanceId, 'inProgress'], true)
				.setIn(['instances', action.instanceId, 'objectId'], action.id)
				.setIn(
					['instances', action.instanceId, 'filters'],
					action.filters
				)
				.setIn(['instances', action.instanceId, 'error'], false)
				.setIn(
					['instances', action.instanceId, 'requestParams'],
					action.requestParams
				);
		}
		case OBJECT_SUCCEEDED: {
			return state
				.setIn(['instances', action.instanceId, 'inProgress'], false)
				.setIn(['instances', action.instanceId, 'error'], false)
				.setIn(
					['instances', action.instanceId, 'object'],
					action.object
				);
		}
		case OBJECT_FAILED:
			return state
				.setIn(['instances', action.instanceId, 'inProgress'], false)
				.setIn(['instances', action.instanceId, 'error'], true)
				.setIn(['instances', action.instanceId, 'objectId'], null);
		case LOCAL_CHANGE_OBJECT_FIELD_REQUESTED: {
			let inState = state;
			const fieldValue = fromJS(
				action.fieldsValueGetters[action.field.name]
					? action.fieldsValueGetters[action.field.name](
						action.field.value
					)
					: action.field.value
			);
			// NOTE: We need to set objectId somehow if requestObject was not called previously
			if (action.field.name === 'id') {
				inState = inState.setIn(
					['instances', action.instanceId, 'objectId'],
					fieldValue
				);
			}

			if (action.merge) {
				return inState
					.mergeIn(
						[
							'instances',
							action.instanceId,
							'object',
							action.field.name,
						],
						fieldValue
					)
					.deleteIn([
						'instances',
						action.instanceId,
						'fieldsErrors',
						action.field.name,
					]);
			}

			return inState
				.setIn(
					[
						'instances',
						action.instanceId,
						'object',
						action.field.name,
					],
					fieldValue
				)
				.deleteIn([
					'instances',
					action.instanceId,
					'fieldsErrors',
					action.field.name,
				]);
		}
		case LOCAL_CREATE_INITIAL_OBJECT: {
			const { object } = action;
			let inState = state;
			// while loading object if it has ID then object ID needs to be set.
			if (object.id) {
				inState = inState.setIn(
					['instances', action.instanceId, 'objectId'],
					object.id
				);
			}
			return inState.setIn(
				['instances', action.instanceId, 'object'],
				fromJS(action.object)
			);
		}
		case REMOVE_OBJECT:
			return state.deleteIn(['instances', action.instanceId]);
		case FILTERS_CHANGED:
			return state
				.setIn(['instances', action.instanceId, 'inProgress'], true)
				.setIn(
					['instances', action.instanceId, 'filters'],
					action.filters
				);
		default:
			break;
	}
	return state;
};
